<template>
  <div class="card">
    <el-image class="img-demo" :src="imgList[tmpType-1]" fit="cover"></el-image>
  </div>
</template>

<script>
export default {
  props: {
    tmpType: String,
  },
  data() {
    return {
      imgList: [
        require('@/assets/images/img-demo.png'),
        'https://img3.quanyou.com.cn/joyNew/group1/M00/1D/90/rB8LrmU3L1qAYOW7AACyzAxZ1uI653.png',
        require('@/assets/images/styleTwo/img.png'),
        'https://img3.quanyou.com.cn/joyNew/group1/M00/1D/CD/rB8LrmU5vVmARSvcAADUOgAyVFc006.png',
        require('@/assets/images/styleFive/tp.png'),
      ],
    }
  }
}
</script>

<style lang="stylus" scoped>
.card
  font-size 0
  .img-demo
    width 100%
</style>